import { useCallback } from 'react';
import Button from '../../../../components/UI/Button/Button';
import { CONSTANTS } from '../../../../utils/constants';
import useTranslations from '../../../../hooks/useTranslations';
import './AddPhonesNumbersFromFile.scss';

interface IAddPhonesNumbersFromFileProps {
  title?: string;
  onMerge: (numbers: string[]) => void;
}

const isPhoneNumber = (str: string) => {
  return CONSTANTS.REGEX_PATTERN_VALIDATORS.PHONE_NUMBER_WITH_OR_WITHOUT_ISRAEL_COUNTRY_CODE.test(
    str
  );
};

const removeCountryCode = (value: string): string => {
  if (!value.startsWith('+972')) return value;
  const rest = value.slice(4);
  return rest.startsWith('0') ? rest : '0' + rest;
};

const AddPhonesNumbersFromFile = ({
  title,
  onMerge,
}: IAddPhonesNumbersFromFileProps) => {
  const { rcTranslate } = useTranslations();
  const handleClick = useCallback(() => {
    const PHONE_NUMBERS_FILE_INPUT_ID = 'phoneNumbersFileInput';
    const input = document.createElement('input');
    input.type = 'file';
    input.id = PHONE_NUMBERS_FILE_INPUT_ID;
    input.accept = '.xlsx,.xls';
    input.style.display = 'none';
    document.body.appendChild(input);

    input.onchange = async (e: any) => {
      const file: File | undefined = e.target.files?.[0];
      if (!file) return;
      try {
        const reader = new FileReader();
        reader.onload = async (evt: any) => {
          try {
            let phoneNumbers: string[] = [];
            try {
              const XLSX = await import('xlsx');
              const data: ArrayBuffer = evt.target.result as ArrayBuffer;
              const workbook = XLSX.read(data, { type: 'array' });
              const sheet = workbook.Sheets[workbook.SheetNames[0]];
              const rows: any[][] = XLSX.utils.sheet_to_json(sheet, {
                header: 1,
              });
              phoneNumbers = rows
                .flat()
                .map((v) => (v == null ? '' : String(v).trim()))
                .filter(isPhoneNumber)
                .map(removeCountryCode);
            } catch (excelErr) {
              console.error('Excel parsing failed', excelErr);
            }

            if (phoneNumbers.length > 0) {
              onMerge(phoneNumbers);
            }
          } catch (err) {
            console.error('Failed parsing phone numbers file', err);
          } finally {
            if (input) input.value = '';
          }
        };
        reader.readAsArrayBuffer(file);
      } catch (err) {
        console.error('Failed reading file', err);
      }
    };

    input.click();
  }, [onMerge]);

  const btnTitle =
    title ??
    rcTranslate('vouchers.vouchersDetails.fieldNames.addPhoneNumbersFromFile');

  return (
    <Button
      title={btnTitle}
      type="button"
      onClick={handleClick}
      className="addPhonesNumbersFromFileButton"
    />
  );
};

export default AddPhonesNumbersFromFile;
